<template>
  <el-form :model="vo">
    <div :class="!moduleInfo.shareList||moduleInfo.isShow?'el-table el-table--fit el-table--border':'el-table el-table--fit'" style="100%">
      <div class="el-table__body-wrapper">
        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body el-table__body-no">
          <tbody>
            <tr>
              <td class="el-table__cell tdlbl tdw17"><span class="required">*</span>文件名称</td>
              <td class="el-table__cell tdcont tdw83">
                <span>{{ vo.resourceName }}</span>
              </td>
            </tr>
            <tr>
              <td class="el-table__cell tdlbl tdw17"><span class="required">*</span>分享范围</td>
              <td colspan="3" class="el-table__cell tdcont tdw83">
                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="指定类型" rules="required">
                  <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                    <el-radio-group v-model="vo.shareScope" @change="changAppoints">
                      <el-radio :label="1">全部</el-radio>
                      <el-radio :label="2">指定部门</el-radio>
                      <el-radio :label="3">指定群组</el-radio>
                      <el-radio :label="4">指定人员</el-radio>
                    </el-radio-group>
                  </el-tooltip>
                </ValidationProvider>
              </td>
            </tr>
            <tr v-if="vo.shareScope !== 1 ">
              <td class="el-table__cell tdlbl tdw17">
                <span class="required">*</span>
                <span v-if="vo.shareScope === 3">
                  选择群组
                </span>
                <span v-if="vo.shareScope === 2">
                  选择部门
                </span>
                <span v-if="vo.shareScope === 4">
                  选择人员
                </span>
              </td>
              <td colspan="3" class="el-table__cell tdcont tdw83">
                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="群组" rules="required">
                  <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                    <el-input v-show="vo.shareScope === 3" v-model="vo.shareObjName" v-select-dialog="'workgroup'" placeholder="请选择群组" readonly="readonly" multiple="true" type="textarea" :root-org-code="vo.orgCode" name="deptIds2" />
                  </el-tooltip>
                </ValidationProvider>
                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="部门" rules="required">
                  <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                    <el-input v-show="vo.shareScope === 2" v-model="vo.shareObjName" v-select-dialog="'suborg'" placeholder="请选择部门" org-level="2" readonly="readonly" multiple="true" type="textarea" :root-org-code="vo.orgCode" name="deptIds" />
                  </el-tooltip>
                </ValidationProvider>
                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="人员" rules="required">
                  <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                    <el-input v-show="vo.shareScope === 4" v-model="vo.shareObjName" v-select-dialog="'staff'" placeholder="请选择人员" readonly="readonly" multiple="true" type="textarea" name="deptIds" :root-org-code="vo.orgCode" />
                  </el-tooltip>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td class="el-table__cell tdlbl tdw17"><span class="required">*</span>访问有效期</td>
              <td colspan="3" class="el-table__cell tdcont tdw83">
                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="访问有效期" rules="required">
                  <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                    <el-radio-group v-model="vo.sharePeriod">
                      <el-radio v-if="!moduleInfo.number" :label="0">永久</el-radio>
                      <el-radio v-if="!moduleInfo.number" :label="1">30天</el-radio>
                      <el-radio v-if="!moduleInfo.number||moduleInfo.number===2" :label="2">7天</el-radio>
                      <el-radio v-if="!moduleInfo.number||moduleInfo.number===2||moduleInfo.number===3" :label="3">1天</el-radio>
                    </el-radio-group>
                  </el-tooltip>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td class="el-table__cell tdlbl tdw17">发送提醒</td>
              <td class="el-table__cell tdcont tdw83">
                <el-input v-if="canEdit" v-model="vo.content" placeholder="请输入提醒内容" />
                <span v-else>{{ vo.content }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </el-form>
</template>

<script>
const moment = require('moment')
export default {
    components: {

    },
    props: {
        moduleInfo: { type: Object, default: function() { return {} } },
        vo: { type: Object, default: function() { return { } } },
        canEdit: { type: Number, default: 1 }
    },
    data() {
        return {
            gwType: [{ title: '单位发文', value: '单位发文' }, { title: '收文阅办', value: '收文阅办' }, { title: '部门收文', value: '部门收文' }, { title: '文件传阅', value: '文件传阅' }, { title: '部门便函', value: '部门便函' }, { title: '意见征集', value: '意见征集' }, { title: '会议通知', value: '会议通知' }, { title: '请示报告', value: '请示报告' }],
            security: [{ title: '一般', value: '1' }, { title: '特殊', value: '2' }],
            gdType: [{ title: '电子归档', value: 1 }, { title: '纸质归档', value: 2 }],
            root: [
            ],
            treeData: [],
            loginUser: null,
            chooseFlGwType: null,
            wflowform: false
        }
    },
    computed: {
        dateTranslate() {
            return (time) => {
                if (time) {
                    return moment(time).format('YYYY年MM月DD日')
                } else {
                    return ''
                }
            }
        },
        timeTranslate() {
            return (time) => {
                if (time) {
                    return moment(time).format('YYYY-MM-DD HH:mm')
                } else {
                    return ''
                }
            }
        }
    },
    watch: {
        'vo.flGwType'(a) {
            const list = (this.vo.passenger.flGwTypeOptions).filter(item => item.name === a)[0]
            if (list !== undefined) {
                this.chooseFlGwType = list.wfName
            }
            // this.vo.wfNodeNames = list.wfEngineUrl
        }
    },
    created() {
        // this.queryData()
        // 如果是分享给我的列表再次分享 分享范围是动态 默认值为当前值的第一个
        if (this.moduleInfo.number) {
            this.vo.sharePeriod = this.moduleInfo.number
        }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
        onWflowFormOpened() {

        },
        onWflowFormBeforeSubmit() {

        },
        onWflowFormSubmited() {

        },
        queryData() {
            // 加载类型节点数据
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: { orderBy: 'categoryLevel asc,orderno asc' },
                data: [
                    { compare: '=', field: 'orgCode', merge: true, value: this.loginUser.orgCode }
                ],
                url: '/disk/folder/classificationQueryCollection'
            }).then(res => {
                if (res.code === 'success') {
                    this.treeData = this.treeData = this.treeDataAdapter(this.root.concat(res.body.listdata))
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                }
            })
        },
        treeDataAdapter(treeData) {
            treeData.forEach(node => {
                if (node.parentId === null || node.parentId === '' || node.parentId === undefined) {
                    node.pId = '1'
                } else {
                    node.pId = node.parentId
                }
                node.name = node.categoryName
                node.title = node.categoryName
            })
            // treeData格式必须遵循ztreeview treeNode规范
            return treeData
        },
        onGdtypeCompleted(selectedNodes, attr) {
            this.vo.categoryName = selectedNodes[0].name
            this.vo.categoryId = selectedNodes[0].categoryFullId
        },
        // 选择部门、科室、班组
        onSelectSuborgCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function(node) {
                if (selected !== '') selected += '、'
                if (selected !== '') selectCode += '、'
                selected += node.name
                selectCode += node.id
            })
            this.$set(this.vo, 'shareObjId', selectCode)
            this.$set(this.vo, 'shareObjName', selected)
        },
        // 选择工作群组
        onSelectWorkgroupCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function(node) {
                if (selected !== '') selected += '、'
                if (selected !== '') selectCode += '、'
                selected += node.name
                selectCode += node.id
            })
            this.$set(this.vo, 'shareObjId', selectCode)
            this.$set(this.vo, 'shareObjName', selected)
        },
        // 选择人员
        onSelectStaffCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function(node) {
                if (selected !== '') selectCode += '、'
                if (selected !== '') selected += '、'
                selected += node.name
                selectCode += node.personId
            })

            this.$set(this.vo, 'shareObjId', selectCode)
            this.$set(this.vo, 'shareObjName', selected)
            console.log(this.vo.shareObjName, 'shareObjName')
        },
        // 切换选项清空
        changAppoints(value) {
            this.vo.shareObjId = ''
            this.vo.shareObjName = ''
        },
        flGwTypeChange() {
            this.vo.number = ''
        },
        // 清除查阅权限
        clearAccessRightsType() {
            this.vo.accessRightsType = null
            this.vo.appoints = null
            this.vo.shareObjName = ''
            this.vo.shareObjId = ''
        }
    }
}
</script>

<style scoped lang="scss">
.el-table__body{
  &.el-table__body-no{
    table-layout:auto
  }
}
/deep/.upload-list{
  width: 100%;
  .el-upload{
    width: 100%;
  }
}
/deep/ .el-divider--horizontal{
        margin:10px 0
    }
</style>
